module.exports = {"name":"breakdown","source":"rawBreakdown","transform":[{"type":"formula","expr":"-summaryBoxSize.width / 2","as":"x"},{"type":"formula","expr":"summaryBoxSize.width","as":"width"},{"type":"formula","expr":"summaryBoxSize.height * parent.multiplier * datum.cumPercentage","as":"y"},{"type":"formula","expr":"summaryBoxSize.height * parent.multiplier * datum.percentage","as":"height"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/summary-nodes/symbol-group/breakdown.json
// module id = um5E
// module chunks = 0